module.exports = __webpack_public_path__ + "img/logo.8e52ddc5.png";